import React from 'react';
import AgentProvider from "./context/agent-context.jsx";
import AgentForm from "./agent-form.jsx";

const AgentFormInit = () => {
    return (
        <AgentProvider>
            <AgentForm />
        </AgentProvider>
    );
};

export default AgentFormInit;